(function () {
  if (window.__mpProductInit) return;
  window.__mpProductInit = true;

  /* iOS Safari zooms the page when a focused input has a *computed*
     font-size under 16px. Customily's own stylesheet can win the CSS
     cascade against ours (more specific selector + !important), so force
     it with an inline style at focus time instead — inline style always
     wins over any external stylesheet. */
  document.addEventListener('focusin', function (event) {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var field = event.target.closest('input, textarea, select');
    if (!field) return;
    if (!field.closest('#customily-options, [id*="customily" i], [class*="customily" i]')) return;
    field.style.setProperty('font-size', '17px', 'important');
  });

  document.querySelectorAll('[data-mp-countdown]').forEach(function (timer) {
    var duration = Number(timer.getAttribute('data-duration-seconds')) || 10800;
    var cooldown = Number(timer.getAttribute('data-cooldown-seconds')) || 21600;
    var key = timer.getAttribute('data-storage-key') || 'mp-flash-sale';
    var now = Date.now();
    var stored = {};

    try {
      stored = JSON.parse(localStorage.getItem(key) || '{}');
    } catch (error) {
      stored = {};
    }

    if (!stored.endsAt || now > Number(stored.endsAt) + cooldown * 1000) {
      stored.endsAt = now + duration * 1000;
      try {
        localStorage.setItem(key, JSON.stringify(stored));
      } catch (error) {}
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function render() {
      var remaining = Math.max(0, Math.floor((Number(stored.endsAt) - Date.now()) / 1000));
      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;
      timer.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }

    render();
    setInterval(render, 1000);
  });

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  document.querySelectorAll('[data-mp-location-selector]').forEach(function (selector) {
    var toggle = selector.querySelector('[data-mp-location-toggle]');
    var name = selector.querySelector('[data-mp-location-name]');
    var flag = selector.querySelector('[data-mp-location-flag]');
    var deliveryChip = selector.querySelector('.mp-product-delivery-chip');
    if (!toggle || !name || !flag) return;

    var countries = [
      ['United States', '🇺🇸'],
      ['Canada', '🇨🇦'],
      ['United Kingdom', '🇬🇧'], ['Germany', '🇩🇪'], ['France', '🇫🇷'], ['Italy', '🇮🇹'],
      ['Spain', '🇪🇸'], ['Netherlands', '🇳🇱'], ['Ireland', '🇮🇪'], ['Sweden', '🇸🇪'],
      ['Norway', '🇳🇴'], ['Denmark', '🇩🇰'], ['Switzerland', '🇨🇭'], ['Belgium', '🇧🇪'],
      ['Austria', '🇦🇹'], ['Portugal', '🇵🇹'], ['Poland', '🇵🇱'], ['Czech Republic', '🇨🇿'],
      ['Hungary', '🇭🇺'], ['Romania', '🇷🇴'], ['Greece', '🇬🇷'], ['Finland', '🇫🇮'],
      ['Australia', '🇦🇺'], ['New Zealand', '🇳🇿'],
      ['Mexico', '🇲🇽'], ['Guatemala', '🇬🇹'], ['Costa Rica', '🇨🇷'], ['Panama', '🇵🇦'],
      ['Brazil', '🇧🇷'], ['Argentina', '🇦🇷'], ['Colombia', '🇨🇴'], ['Chile', '🇨🇱'],
      ['Peru', '🇵🇪'], ['Venezuela', '🇻🇪'], ['Ecuador', '🇪🇨'],
      ['Japan', '🇯🇵'], ['South Korea', '🇰🇷'], ['Singapore', '🇸🇬'], ['China', '🇨🇳'],
      ['Hong Kong', '🇭🇰'], ['Taiwan', '🇹🇼'], ['Thailand', '🇹🇭'], ['Vietnam', '🇻🇳'],
      ['Indonesia', '🇮🇩'], ['Philippines', '🇵🇭'], ['Malaysia', '🇲🇾'], ['India', '🇮🇳'],
      ['United Arab Emirates', '🇦🇪'], ['Saudi Arabia', '🇸🇦'], ['Israel', '🇮🇱'],
      ['South Africa', '🇿🇦']
    ];
    /* Single source of truth for delivery estimates: [min, max] total days
       from order to delivery. Box 1 (this chip) and Box 2 (the timeline
       below it, .mp-product-delivery-box) both read from this same map so
       they can never show two different numbers for the same country. */
    var deliveryByCountry = {
      'United States': [7, 14],
      'Canada': [15, 40],
      'United Kingdom': [15, 40],
      'Germany': [15, 40],
      'France': [15, 40],
      'Italy': [15, 40],
      'Spain': [15, 40],
      'Netherlands': [15, 40],
      'Ireland': [15, 40],
      'Sweden': [15, 40],
      'Norway': [15, 40],
      'Denmark': [15, 40],
      'Switzerland': [15, 40],
      'Belgium': [15, 40],
      'Austria': [15, 40],
      'Portugal': [15, 40],
      'Poland': [15, 40],
      'Czech Republic': [15, 40],
      'Hungary': [15, 40],
      'Romania': [15, 40],
      'Greece': [15, 40],
      'Finland': [15, 40],
      'Australia': [15, 45],
      'New Zealand': [15, 45],
      'Mexico': [20, 60],
      'Guatemala': [20, 60],
      'Costa Rica': [20, 60],
      'Panama': [20, 60],
      'Brazil': [20, 60],
      'Argentina': [20, 60],
      'Colombia': [20, 60],
      'Chile': [20, 60],
      'Peru': [20, 60],
      'Venezuela': [20, 60],
      'Ecuador': [20, 60],
      'Japan': [20, 40],
      'South Korea': [20, 40],
      'Singapore': [20, 40],
      'China': [20, 40],
      'Hong Kong': [20, 40],
      'Taiwan': [20, 40],
      'Thailand': [20, 40],
      'Vietnam': [20, 40],
      'Indonesia': [20, 40],
      'Philippines': [20, 40],
      'Malaysia': [20, 40],
      'India': [20, 40],
      'United Arab Emirates': [20, 40],
      'Saudi Arabia': [20, 40],
      'Israel': [20, 40],
      'South Africa': [20, 60]
    };
    var DEFAULT_RANGE = [15, 40];
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function getRange(countryName) {
      return deliveryByCountry[countryName] || DEFAULT_RANGE;
    }

    function formatRangeText(range) {
      return range[0] + '-' + range[1] + ' days';
    }

    function addDays(date, days) {
      var result = new Date(date.getTime());
      result.setDate(result.getDate() + days);
      return result;
    }

    function formatShortDate(date) {
      return MONTHS[date.getMonth()] + ' ' + date.getDate();
    }

    function updateDeliveryText(countryName) {
      if (!deliveryChip) return;
      var textNode = Array.from(deliveryChip.childNodes).find(function (node) {
        return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
      });
      if (textNode) textNode.textContent = ' ' + formatRangeText(getRange(countryName)) + ' ';
    }

    /* Keep Box 2 (the order-placed / ships / delivered timeline) in sync
       with whatever country is selected in Box 1 above it. */
    function updateDeliveryBox(countryName) {
      var box = selector.closest('.product__info-container');
      box = box && box.querySelector('[data-mp-delivery-box]');
      if (!box) return;

      var range = getRange(countryName);
      var productionDays = parseInt(box.getAttribute('data-mp-production-days'), 10) || 1;
      var today = new Date();

      var shipsEl = box.querySelector('.mp-product-delivery-timeline__date--ships');
      var deliveredEl = box.querySelector('.mp-product-delivery-timeline__date--delivered');
      if (shipsEl) shipsEl.textContent = formatShortDate(addDays(today, productionDays));
      if (deliveredEl) {
        deliveredEl.textContent = formatShortDate(addDays(today, range[0])) + '-' + formatShortDate(addDays(today, range[1]));
      }

      var disclaimerEl = box.querySelector('[data-mp-disclaimer-text]');
      if (disclaimerEl) {
        disclaimerEl.textContent = countryName === 'United States'
          ? box.getAttribute('data-mp-disclaimer-us')
          : 'International estimates are approximate and may vary with customs.';
      }
    }

    /* Sync Box 2 to whatever country Box 1 shows by default, on first paint. */
    updateDeliveryBox(name.textContent.trim() || 'United States');

    function ensureModal() {
      var modal = document.querySelector('.mp-location-modal');
      if (modal) return modal;

      modal = document.createElement('div');
      modal.className = 'mp-location-modal';
      modal.hidden = true;
      modal.innerHTML = [
        '<button class="mp-location-modal__overlay" type="button" data-mp-location-close aria-label="Close country selector"></button>',
        '<form class="mp-location-modal__panel" data-mp-location-form>',
          '<button class="mp-location-modal__close" type="button" data-mp-location-close aria-label="Close">×</button>',
          '<h2>Select your shipping country</h2>',
          '<label for="mp-location-country">Country</label>',
          '<select id="mp-location-country" data-mp-location-select></select>',
          '<button class="mp-location-modal__submit" type="submit">Submit</button>',
        '</form>'
      ].join('');
      document.body.appendChild(modal);

      var select = modal.querySelector('[data-mp-location-select]');
      select.innerHTML = countries.map(function (country) {
        return '<option value="' + country[0] + '" data-flag="' + country[1] + '">' + country[1] + ' ' + country[0] + '</option>';
      }).join('');

      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-mp-location-close]')) closeModal(modal);
      });

      modal.querySelector('[data-mp-location-form]').addEventListener('submit', function (event) {
        event.preventDefault();
        var option = select.options[select.selectedIndex];
        name.textContent = option.value;
        flag.textContent = option.getAttribute('data-flag') || '🇺🇸';
        updateDeliveryText(option.value);
        updateDeliveryBox(option.value);
        closeModal(modal);
      });

      return modal;
    }

    function closeModal(modal) {
      modal.hidden = true;
      modal.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      var modal = ensureModal();
      var select = modal.querySelector('[data-mp-location-select]');
      if (select) select.value = name.textContent.trim() || 'United States';
      modal.hidden = false;
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      toggle.setAttribute('aria-expanded', 'true');
    });
  });

  document.querySelectorAll('[data-mp-bundle]').forEach(function (bundle) {
    var total = bundle.querySelector('[data-mp-bundle-total]');
    var addButton = bundle.querySelector('[data-mp-bundle-add]');
    var inputs = Array.from(bundle.querySelectorAll('.mp-product-bundle__input'));
    var items = Array.from(bundle.querySelectorAll('[data-mp-bundle-item]'));

    function selectedItems() {
      return items.filter(function (item) {
        var input = item.querySelector('.mp-product-bundle__input');
        return !input || input.checked;
      });
    }

    function sync() {
      var selected = selectedItems();
      var sum = selected.reduce(function (memo, item) {
        return memo + (Number(item.getAttribute('data-bundle-price')) || 0);
      }, 0);

      items.forEach(function (item) {
        var input = item.querySelector('.mp-product-bundle__input');
        item.classList.toggle('is-selected', !input || input.checked);
      });

      if (total) total.textContent = formatMoney(sum);
      if (addButton) addButton.textContent = 'Add ' + selected.length + (selected.length === 1 ? ' item' : ' items');
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', sync);
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        var cartItems = selectedItems().map(function (item) {
          return {
            id: Number(item.getAttribute('data-bundle-variant-id')),
            quantity: 1
          };
        }).filter(function (item) { return item.id; });

        if (!cartItems.length) return;
        addButton.classList.add('is-loading');
        addButton.disabled = true;

        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Bundle add failed');
            return response.json();
          })
          .then(function () {
            window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
          })
          .catch(function () {
            addButton.classList.remove('is-loading');
            addButton.disabled = false;
            addButton.textContent = 'Try again';
            window.setTimeout(sync, 1400);
          });
      });
    }

    sync();
  });

  document.querySelectorAll('[data-mp-addon-toggle]').forEach(function (container) {
    var form = document.querySelector('.mp-product-page form[data-type="add-to-cart-form"]');
    if (!form) return;
    var checkbox = container.querySelector('[data-mp-addon-checkbox]');
    if (!checkbox) return;
    var variantId = container.getAttribute('data-mp-addon-variant-id') || '';

    var input = form.querySelector('[data-mp-addon-property]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      form.appendChild(input);
    }
    input.setAttribute('data-mp-addon-property', '');
    input.setAttribute('data-mp-addon-variant-id', variantId);

    var storageKey = 'mp_addon_off_' + variantId;
    var defaultActive = sessionStorage.getItem(storageKey) !== '1';

    checkbox.checked = defaultActive;
    input.disabled = !defaultActive;
    container.classList.toggle('is-active', defaultActive);

    checkbox.addEventListener('change', function () {
      var active = checkbox.checked;
      input.disabled = !active;
      container.classList.toggle('is-active', active);
      if (active) {
        sessionStorage.removeItem(storageKey);
      } else {
        sessionStorage.setItem(storageKey, '1');
      }
    });
  });


  // Inject CSS to hide unavailable variant pills (more reliable than CSS file cache)
  (function () {
    var style = document.createElement('style');
    style.textContent =
      '.mp-product-page variant-selects input[type="radio"].disabled,' +
      '.mp-product-page variant-selects input[type="radio"].disabled+label,' +
      '.mp-product-page variant-radios input[type="radio"].disabled,' +
      '.mp-product-page variant-radios input[type="radio"].disabled+label{display:none!important}';
    document.head.appendChild(style);
  })();

  (function () {
    var popup = document.querySelector('.mp-addon-popup');
    if (!popup) return;
    var popupImg = popup.querySelector('.mp-addon-popup__img');
    var popupTitle = popup.querySelector('.mp-addon-popup__title');
    var popupPrice = popup.querySelector('.mp-addon-popup__price');

    function openPopup(src, alt, title, price) {
      popupImg.src = src;
      popupImg.alt = alt;
      popupTitle.textContent = title;
      popupPrice.textContent = price;
      popup.setAttribute('aria-hidden', 'false');
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.setAttribute('aria-hidden', 'true');
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    popup.querySelectorAll('[data-mp-addon-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    document.querySelectorAll('[data-mp-addon-img-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPopup(btn.dataset.imgSrc, btn.dataset.imgAlt, btn.dataset.imgTitle, btn.dataset.imgPrice);
      });
    });
  })();

  document.querySelectorAll('[data-mp-protection-toggle]').forEach(function (button) {
    var form = document.querySelector('.mp-product-page form[data-type="add-to-cart-form"]');
    if (!form) return;
    var switchButton = button.querySelector('[data-mp-protection-switch]');

    var input = form.querySelector('[data-mp-protection-property]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      form.appendChild(input);
    }
    input.setAttribute('data-mp-protection-property', '');
    input.setAttribute('data-mp-protection-variant-id', button.getAttribute('data-mp-protection-variant-id') || '');

    function sync(active) {
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (switchButton) switchButton.setAttribute('aria-pressed', active ? 'true' : 'false');
      input.disabled = !active;
      if (active) {
        sessionStorage.removeItem('mp_prot_off');
      } else {
        sessionStorage.setItem('mp_prot_off', '1');
      }
    }

    button.addEventListener('click', function (event) {
      if (!event.target.closest('[data-mp-protection-switch]')) return;
      sync(button.getAttribute('aria-pressed') !== 'true');
    });

    // Default active unless user previously unchecked in this session
    var defaultActive = button.classList.contains('is-active') && sessionStorage.getItem('mp_prot_off') !== '1';
    sync(defaultActive);
  });

  document.addEventListener('click', function (event) {
    var finalButton = event.target.closest('[data-mp-final-add]');
    if (!finalButton) return;
    var form = document.querySelector('.mp-product-page form[data-type="add-to-cart-form"]');
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }
    var submit = form ? form.querySelector('[type="submit"]') : document.querySelector('.mp-product-page .product-form__submit');
    if (submit) submit.click();
  });

  document.querySelectorAll('[data-mp-copy-code]').forEach(function (button) {
    button.addEventListener('click', function () {
      var code = button.getAttribute('data-mp-copy-code') || '';
      var original = button.textContent;

      function markCopied() {
        button.classList.add('is-copied');
        button.textContent = 'Copied';
        window.setTimeout(function () {
          button.classList.remove('is-copied');
          button.textContent = original;
        }, 1400);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(markCopied).catch(markCopied);
      } else {
        markCopied();
      }
    });
  });

  document.querySelectorAll('[data-mp-copy-link]').forEach(function (button) {
    button.addEventListener('click', function () {
      var link = button.getAttribute('data-mp-copy-link') || window.location.href;

      function markCopied() {
        button.classList.add('is-copied');
        window.setTimeout(function () {
          button.classList.remove('is-copied');
        }, 1400);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(markCopied).catch(markCopied);
      } else {
        markCopied();
      }
    });
  });

  document.querySelectorAll('.product__media-wrapper slider-component').forEach(function (sliderComponent) {
    var slider = sliderComponent.querySelector('[id^="Slider-"]');
    var slides = Array.from(sliderComponent.querySelectorAll('[id^="Slide-"]'));
    var dots = Array.from(sliderComponent.querySelectorAll('[data-mp-media-dot]'));
    if (!slider || !slides.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('slider-counter__link--active', dotIndex === index);
        if (dotIndex === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.getAttribute('data-mp-media-dot')) || 0;
        var slide = slides[index];
        if (!slide) return;
        slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActive(index);
      });
    });

    slider.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        var currentIndex = 0;
        var smallestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slider.scrollLeft - slide.offsetLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            currentIndex = index;
          }
        });
        setActive(currentIndex);
      });
    }, { passive: true });
  });

  // Sticky ATC bar: slide up when buy-box scrolls off screen, hide when visible
  var stickyAtc = document.querySelector('.mp-product-sticky-atc');
  if (stickyAtc && 'IntersectionObserver' in window) {
    var cartNotification = document.getElementById('cart-notification');
    function syncCartPopupState() {
      stickyAtc.classList.toggle('is-cart-popup-open', Boolean(cartNotification && cartNotification.classList.contains('active')));
    }

    function getBuyBox() {
      // Prefer the add-to-cart button that is actually visible. Customily hides
      // the native .product-form__submit and renders its own (#customily-cart-btn),
      // so observing the first match blindly can mean observing a display:none node.
      var candidates = document.querySelectorAll('.mp-product-page .product-form__submit, .mp-product-page #customily-cart-btn');
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].offsetParent !== null) return candidates[i];
      }
      return candidates[0] || document.querySelector('.mp-product-page .product__info-wrapper');
    }

    var atcObserver = null;
    var observedBuyBox = null;

    function attachAtcObserver() {
      var buyBox = getBuyBox();
      if (!buyBox || buyBox === observedBuyBox) return;
      if (atcObserver) atcObserver.disconnect();
      observedBuyBox = buyBox;
      atcObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // Reveal only once the buy box has scrolled ABOVE the top of the viewport
        // (the user has passed it) — NOT while it is still below the fold at page
        // load. Otherwise the sticky bar shows immediately on load (mobile).
        var passedBuyBox = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyAtc.classList.toggle('is-visible', passedBuyBox);
        syncCartPopupState();
      }, { threshold: 0 });
      atcObserver.observe(buyBox);
    }

    attachAtcObserver();

    /* Personalization apps (e.g. Customily) can re-render the add-to-cart
       button after page load, detaching the node we were observing. Watch
       for that and re-attach to the live button so the sticky bar doesn't
       end up stuck visible alongside the app's own button. */
    var formWatchTarget = document.querySelector('.mp-product-page .product-form') || document.querySelector('.mp-product-page .product__info-container');
    if (formWatchTarget && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (!observedBuyBox || !observedBuyBox.isConnected) {
          attachAtcObserver();
        }
      }).observe(formWatchTarget, { childList: true, subtree: true });
    }

    if (cartNotification && 'MutationObserver' in window) {
      new MutationObserver(syncCartPopupState).observe(cartNotification, { attributes: true, attributeFilter: ['class'] });
    }
    syncCartPopupState();
  }

  document.querySelectorAll('.mp-product-page .product__accordion details').forEach(function (details) {
    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    if (!summary || !content) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animation;

    summary.addEventListener('click', function (event) {
      if (prefersReducedMotion) return;
      event.preventDefault();

      if (animation) animation.cancel();

      if (details.open) {
        var startHeight = content.offsetHeight;
        animation = content.animate(
          [
            { height: startHeight + 'px', opacity: 1 },
            { height: 0, opacity: 0 }
          ],
          { duration: 240, easing: 'cubic-bezier(.2,.7,.2,1)' }
        );
        animation.onfinish = function () {
          details.open = false;
          content.style.height = '';
          content.style.opacity = '';
        };
      } else {
        details.open = true;
        content.style.height = 'auto';
        var endHeight = content.offsetHeight;
        animation = content.animate(
          [
            { height: 0, opacity: 0 },
            { height: endHeight + 'px', opacity: 1 }
          ],
          { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)' }
        );
        animation.onfinish = function () {
          content.style.height = '';
          content.style.opacity = '';
        };
      }
    });
  });
  document.querySelectorAll('[data-mp-demand]').forEach(function (el) {
    var productId = parseInt(el.getAttribute('data-mp-demand'), 10) || 0;
    var dayNum = Math.floor(Date.now() / 86400000);
    var seed = productId * 7 + dayNum * 13;
    var x = Math.sin(seed + 1) * 10000;
    var r = x - Math.floor(x);
    var count = 14 + Math.floor(r * 54);
    var countEl = el.querySelector('.mp-demand-count');
    if (countEl) countEl.textContent = count;
  });

})();

// ── Modal pinch-to-zoom (mobile) ──────────────────────────────────────────────
(function () {
  if (window.matchMedia('(pointer: coarse)').matches === false) return;

  customElements.whenDefined('product-modal').then(function () {
    var modal = document.querySelector('product-modal.product-media-modal');
    if (!modal || modal._mpz) return;
    modal._mpz = true;

    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;

    var sc = 1, sc0 = 1, d0 = 1;

    function hyp(ta) {
      var dx = ta[0].clientX - ta[1].clientX;
      var dy = ta[0].clientY - ta[1].clientY;
      return Math.sqrt(dx * dx + dy * dy) || 1;
    }

    function activeEl() {
      return modal.querySelector('[data-media-id].active');
    }

    content.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        d0 = hyp(e.touches);
        sc0 = sc;
      }
    }, { passive: true });

    content.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 2) return;
      e.preventDefault();
      var t = activeEl();
      if (!t) return;
      sc = Math.max(1, Math.min(4, sc0 * hyp(e.touches) / d0));
      t.style.transformOrigin = '50% 50%';
      t.style.transform = 'scale(' + sc + ')';
    }, { passive: false });

    content.addEventListener('touchend', function (e) {
      if (e.touches.length > 0) return;
      if (sc < 1.08) {
        var t = activeEl();
        sc = 1;
        if (t) {
          t.style.transition = 'transform 0.22s ease';
          t.style.transform = 'scale(1)';
          setTimeout(function () { t.style.transition = ''; }, 240);
        }
      }
    }, { passive: true });

    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) {
        var t = activeEl();
        if (t) { t.style.transform = ''; t.style.transition = ''; }
        sc = 1;
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  });
})();
